module.exports = __webpack_public_path__ + "img/cenone_capodanno.1e3a8784.png";